export default {
    selectProjects: 'Projekte auswählen',
    themeColor: 'Grundfarbe',
    Logo: 'Logo',
    addLogo: 'Logo hinzufügen',
    noProjectsSelected: 'Keine Projekte ausgewählt',
    nameForZip: 'Name für Zip-Datei'
}